import MuiModal from '@mui/material/Modal';
import { styled } from '@mui/material/styles';
import { getPrismScrollbarTargetStyles } from 'theme';

export const StyledModal = styled(MuiModal)(({ theme }) => ({
  ...getPrismScrollbarTargetStyles(theme, '& :where(*)', {
    thumbBorderColor: theme.palette.background.paper,
  }),
})) as typeof MuiModal;
